import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { APP_CONFIG } from '@moawen-workspace/shared';


export const baseUrlInterceptor: HttpInterceptorFn = (req, next) => {
  const appConfig = inject(APP_CONFIG);
  let url = '';
  if (req.url.startsWith('/assets')) {
    return next(req);
  }
  if (req.url === "/Passport/parse") {
    url = `https://moawen-ocr-api.fit-infotech.com/api${req.url}`
  } else {
    url = `${appConfig.baseUrl}${req.url}`
  }

  req = req.clone({
    // url: `https://moawen-agency-api.fit-infotech.com/api${req.url}`
    url: url

  });

  return next(req);
};
